export const CYCLE_TYPES = {
  STUDY: 'study',
  OTHER: 'other'
};
